import { createActionGroup, props } from '@ngrx/store';
import { CategoryType, ErrorModel } from '@rocksoft/shared';
import { VppApplicationConfiguration } from './category-vpp-applications.state';

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryVppApplicationsApiActions = createActionGroup({
  source: 'Category VPP Applications API',
  events: {
    'Application Configurations Updated Error': props<{
      categoryId: string;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryVppApplicationsViewActions = createActionGroup({
  source: 'Category VPP Application View',
  events: {
    'Application Configurations Updated': props<{
      categoryId: string;
      categoryType: CategoryType;
      previousApplicationsLinkedToCategory: VppApplicationConfiguration[];
      updatedApplicationsLinkedToCategory: VppApplicationConfiguration[];
    }>(),
  },
});
